import Button from '@mui/material/Button';
import {forwardRef, memo} from 'react';

const MUIButton = forwardRef((props: any, ref: any) => {
    const {type, label, onClick, disabled, variant, className, fullWidth, startIcon, endIcon, sx, ...rest} = props;
    return (
        <Button
            ref={ref}
            type={type}
            variant={variant}
            className={className}
            onClick={onClick}
            disabled={disabled}
            fullWidth={fullWidth}
            startIcon={startIcon}
            endIcon={endIcon}
            sx={sx}
            {...rest}
        >
            {label}
        </Button>
    );
});

MUIButton.displayName = 'MUIButton';
export default memo(MUIButton);
